import { EmbarcacoesScreen } from "@/screens/embarcacoes";

/** Thin wrapper — toda lógica fica em screens/embarcacoes */
export function EmbarcacoesPage() {
  return <EmbarcacoesScreen />;
}
